// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__1kxe0","card":"card__1h19d","iconCircle":"iconCircle__3Uyoq"};